'use strict';

const notImplementedError = Error('Not implemented');

export default class iLoreService {
  getAllLore() {
    throw new notImplementedError;
  }
  getLoreById() {
    throw new notImplementedError;
  }
  addLore() {
    throw new notImplementedError;
  }
  updateLore() {
    throw new notImplementedError;
  }
}
